export interface TypeAHeadOption {
    label: string;
    value: string;
};
export interface TypeAHeadSelectEvent extends TypeAHeadOption {
    index: number
}

export enum SearchListCategory {
    ALL = "all",
    VESSEL = "vessel",
    PORT = "port"
}

export enum ItemType {
    VESSEL = "vessel",
    PORT = "port",
    PORT_REGION = "portRegion"
}
